import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon7: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 20.0

  const originalHeight = 20.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 20 20" width={width} height={height} {...props}>
      <Path
        d="M5.843 0C6.78148 0 7.62147 0.583996 7.94958 1.465L8.7207 3.536C9.1399 4.665 8.5948 5.92401 7.48481 6.39101L5.29863 7.31C6.79768 10.045 9.9662 13.217 12.6903 14.702L13.6089 12.516C14.0747 11.405 15.3353 10.86 16.4642 11.28L18.5348 12.05C19.4156 12.377 20 13.218 20 14.157V17.386C20 18.83 18.8293 20 17.385 20C7.7832 20 0 12.216 0 2.61501C0 1.17101 1.16998 0 2.614 0H5.843ZM5.843 1H2.614C1.72241 1 1 1.72301 1 2.61501C1 11.664 8.3355 19 17.385 19C18.2771 19 19 18.278 19 17.386V14.157C19 13.636 18.6757 13.169 18.1868 12.988L16.1155 12.218C15.4889 11.984 14.7893 12.287 14.531 12.903L13.403 15.588C13.2915 15.853 12.9798 15.97 12.7215 15.843L12.6653 15.815C9.5009 14.268 5.69437 10.448 4.15615 7.27699C4.03101 7.01899 4.14792 6.70901 4.41219 6.59801L7.09714 5.46899C7.71333 5.20999 8.016 4.511 7.78342 3.884L7.0125 1.814C6.8302 1.325 6.36357 1 5.843 1ZM9.9996 0C15.5227 0 19.9996 4.477 19.9996 10C19.9996 10.277 19.7757 10.5 19.4996 10.5C19.2235 10.5 18.9996 10.277 18.9996 10C18.9996 5.03 14.9705 1 9.9996 1C9.7235 1 9.4996 0.777 9.4996 0.5C9.4996 0.224 9.7235 0 9.9996 0ZM9.9999 2.429C14.181 2.429 17.5709 5.819 17.5709 10C17.5709 10.277 17.347 10.5 17.0709 10.5C16.7948 10.5 16.5709 10.277 16.5709 10C16.5709 6.372 13.6288 3.429 9.9999 3.429C9.7238 3.429 9.4999 3.206 9.4999 2.929C9.4999 2.653 9.7238 2.429 9.9999 2.429Z"
        fill="#F3123C"
      />
    </Icon>
  )
}
